import React from 'react'
import type { GridProps } from '@vtex/admin-ui'
import { Grid, csx, cx } from '@vtex/admin-ui'

export type SalesAssociatesContentProps = GridProps

export const SalesAssociatesContent = ({
  className = '',
  ...props
}: SalesAssociatesContentProps) => (
  <Grid
    className={cx(
      csx({
        marginY: '$space-6',
        gridGap: '0.875rem',
        '@tablet': {
          gridGap: '1rem',
          gridTemplateColumns: 'repeat(2, 1fr)',
        },
        '@desktop': {
          gridTemplateColumns: 'repeat(3, 1fr)',
        },
      }),
      className
    )}
  >
    {props.children}
  </Grid>
)
